import React, { useState } from "react";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import PageTabItemTitle from "components/tabs/TabItem/PageTabItemTitle";
import MatterCalculation from "./MatterCalculation";

const InterestCalculator = () => {
    const [selected, setSelected] = useState(0);

    return (
        <div className="page h-100">
            <TabStrip
                selected={selected}
                className="pagetab w-100 h-100"
                keepTabsMounted={true}
                onSelect={(e) => setSelected(e.selected)}
            >
                <TabStripTab
                    title={<PageTabItemTitle title="Matter Calculation" />}
                    contentClassName="h-100"
                >
                    <MatterCalculation />
                </TabStripTab>
                <TabStripTab
                    title={<PageTabItemTitle title="Adhoc Interest Calculation" />}
                    contentClassName="h-100"
                >
                    <div />
                </TabStripTab>
            </TabStrip>
        </div>
    );
};

export default InterestCalculator;
